"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _1 = require(".");
var __1 = require("..");
var element_1 = require("../element");
var utils_1 = require("../template/utils");
var geometry_1 = require("../geometry");
var HierarchyLayout = /** @class */ (function (_super) {
    __extends(HierarchyLayout, _super);
    function HierarchyLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HierarchyLayout.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_valueFunc":
            case "_sortingFunc":
            case "_labelFunc":
            case "_labelPartitionFunc":
                return utils_1.parseFunc(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    HierarchyLayout.prototype.defaultOptions = function () {
        return {
            _valueFunc: function (d) { return d.size; },
            _labelFunc: function (d) { return d.name; },
            _sortingFunc: function (a, b) { return b.value - a.value; },
            _labelPartitionFunc: null,
        };
    };
    HierarchyLayout.prototype.init = function () {
        this._toolTip = __1.tooltip.create("nodetip");
        this._groups = this.appendGroupT(_1.Component).data([]).options({});
    };
    HierarchyLayout.prototype.prepare = function () {
        this._cachedHeight = this._getGeometry("_height", false);
        this._cachedWidth = this._getGeometry("_width", true);
        this._root = d3.hierarchy(this.datum)
            .sum(this.getOption("_valueFunc"))
            .sort(this.getOption("_sortingFunc"));
    };
    return HierarchyLayout;
}(_1.Component));
exports.HierarchyLayout = HierarchyLayout;
var Treemap = /** @class */ (function (_super) {
    __extends(Treemap, _super);
    function Treemap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Treemap.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_tileFunc":
                return utils_1.parseFunc(value);
            case "_isRound":
                return utils_1.parseBoolean(value);
            case "_innerPadding":
            case "_outerPadding":
                return utils_1.parsePadding(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    Treemap.prototype.defaultOptions = function () {
        return __assign(__assign({}, _super.prototype.defaultOptions.call(this)), { _tileFunc: d3.treemapSquarify, _isRound: true, _innerPadding: 1, _outerPadding: 1, _labelPartitionFunc: function (s) { return s.split(/(?=[A-Z][^A-Z])/g); } });
    };
    Treemap.prototype.init = function () {
        var _this = this;
        _super.prototype.init.call(this);
        this._groups.options({
            _x: function (d) { return d.x0; },
            _y: function (d) { return d.y0; },
            _width: function (d) { return d.x1 - d.x0; },
            _height: function (d) { return d.y1 - d.y0; },
            _clipPath: function (d) { return "<rect x=\"0\" y=\"0\" width=\"" + (d.x1 - d.x0) + "\" height=\"" + (d.y1 - d.y0) + "\">"; },
        });
        this._rects = this._groups.appendT(element_1.Rect).options({
            _anchor: 2 /* Top */ | 16 /* Left */,
            _x: 0,
            _y: 0,
            _width: geometry_1.GeometryValue.fullSize,
            _height: geometry_1.GeometryValue.fullSize,
            _$postAppend: function () {
                _this._toolTip.attachTo(_this._rects.dom)
                    .renderHTML(function (d) { return _this.getOption("_labelFunc")(d.data) + ": " + _this.getOption("_valueFunc")(d.data); });
            },
        });
        this._labels = this._groups.appendT(element_1.Text).options({
            _anchor: 8 /* Bottom */ | 16 /* Left */,
            _relatedTo: 2 /* Top */ | 16 /* Left */,
            _html: function (d) {
                // Split the Title Case
                var classes = _this.getOption("_labelPartitionFunc")(_this.getOption("_labelFunc")(d.data));
                return classes.map(function (s) { return "<tspan x=\"0\" dy=\"1em\">" + s + "</tspan>"; })
                    .concat(["<tspan x=\"0\" dy=\"1em\">" + _this.getOption("_valueFunc")(d.data) + "</tspan>"])
                    .join("");
            },
        });
    };
    Treemap.prototype.prepare = function () {
        _super.prototype.prepare.call(this);
        var treemap = d3.treemap()
            .size([this._cachedWidth, this._cachedHeight])
            .paddingInner(this.getOption("_innerPadding"))
            .tile(this.getOption("_tileFunc"));
        // Add outer padding
        var outerPadding = this.getOption("_outerPadding");
        if (isNaN(outerPadding)) {
            treemap.paddingTop(outerPadding[0])
                .paddingRight(outerPadding[1])
                .paddingBottom(outerPadding[2])
                .paddingLeft(outerPadding[3]);
        }
        else {
            treemap.paddingOuter(outerPadding);
        }
        var transedRoot = treemap(this._root);
        var data = transedRoot.leaves().map(function (d) {
            d.root = transedRoot;
            return d;
        });
        this._groups.data(data);
        this.setupProxy({
            rect: "_rects",
            label: "_labels",
        });
    };
    return Treemap;
}(HierarchyLayout));
exports.Treemap = Treemap;
var CirclePacking = /** @class */ (function (_super) {
    __extends(CirclePacking, _super);
    function CirclePacking() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CirclePacking.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_padding":
                return utils_1.parsePadding(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    CirclePacking.prototype.defaultOptions = function () {
        return __assign(__assign({}, _super.prototype.defaultOptions.call(this)), { _labelPartitionFunc: function (s) { return s.split(/(?=[A-Z][^A-Z])/g); }, _padding: 1 });
    };
    CirclePacking.prototype.init = function () {
        var _this = this;
        _super.prototype.init.call(this);
        this._groups.options({
            _x: function (d) { return d.x; },
            _y: function (d) { return d.y; },
            _clipPath: function (d) { return "<circle cx=\"0\" cy=\"0\" r=\"" + d.r + "\">"; },
        });
        this._circles = this._groups.appendT(element_1.Circle).options({
            _r: function (d) { return d.r; },
            _$postAppend: function () {
                _this._toolTip.attachTo(_this._circles.dom)
                    .renderHTML(function (d) { return _this.getOption("_labelFunc")(d.data) + ": " + d.value; });
            },
        });
        this._labels = this._groups.appendT(element_1.Text).options({
            _anchor: 8 /* Bottom */ | 32 /* Center */,
            _relatedTo: 2 /* Top */ | 32 /* Center */,
            _html: function (d) {
                // Split the Title Case
                var classes = _this.getOption("_labelPartitionFunc")(_this.getOption("_labelFunc")(d.data));
                return classes.map(function (s, i) { return "<tspan x=\"0\" dy=\"" + i + "em\">" + s + "</tspan>"; })
                    .concat(["<tspan x=\"0\" dy=\"" + classes.length + "em\">" + _this.getOption("_valueFunc")(d.data) + "</tspan>"])
                    .join("");
            },
            visibility: function (d) { return !d.children ? "1" : "0"; },
        });
    };
    CirclePacking.prototype.prepare = function () {
        _super.prototype.prepare.call(this);
        var radius = d3.min([this._cachedHeight, this._cachedWidth]);
        var pack = d3.pack()
            .size([radius, radius])
            .padding(this.getOption("_padding"));
        var nodes = pack(this._root).descendants();
        this._groups.data(nodes);
        this.setupProxy({
            circle: "_circles",
            label: "_labels",
        });
    };
    return CirclePacking;
}(HierarchyLayout));
exports.CirclePacking = CirclePacking;
var Partition = /** @class */ (function (_super) {
    __extends(Partition, _super);
    function Partition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Partition.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_isRound":
                return utils_1.parseBoolean(value);
            case "_padding":
                return utils_1.parseNumberWithAuto(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    Partition.prototype.defaultOptions = function () {
        return __assign(__assign({}, _super.prototype.defaultOptions.call(this)), { _padding: 1, _isRound: true });
    };
    Partition.prototype.init = function () {
        var _this = this;
        _super.prototype.init.call(this);
        this._groups.options({
            _x: function (d) { return d.y0; },
            _y: function (d) { return d.x0; },
            _width: function (d) { return d.y1 - d.y0; },
            _height: function (d) { return d.x1 - d.x0; },
            _clipPath: function (d) { return "<rect x=\"0\" y=\"0\" width=\"" + (d.y1 - d.y0) + "\" height=\"" + (d.x1 - d.x0) + "\">"; },
        });
        this._rects = this._groups.appendT(element_1.Rect).options({
            _anchor: 2 /* Top */ | 16 /* Left */,
            _x: 0,
            _y: 0,
            _width: geometry_1.GeometryValue.fullSize,
            _height: geometry_1.GeometryValue.fullSize,
            _$postAppend: function () {
                _this._toolTip.attachTo(_this._rects.dom)
                    .renderHTML(function (d) { return _this.getOption("_labelFunc")(d.data) + ": " + d.value; });
            },
        });
        this._labels = this._groups.appendT(element_1.Text).options({
            _anchor: 2 /* Top */ | 16 /* Left */,
            _relatedTo: 2 /* Top */ | 16 /* Left */,
            _text: function (d) { return _this.getOption("_labelFunc")(d.data) + ": " + d.value; },
        });
    };
    Partition.prototype.prepare = function () {
        _super.prototype.prepare.call(this);
        var partition = d3.partition()
            .size([this._cachedHeight, this._cachedWidth])
            .padding(this.getOption("_padding"))
            .round(this.getOption("_isRound"));
        var transedRoot = partition(this._root);
        var data = this._root.descendants().map(function (d) {
            d.root = transedRoot;
            return d;
        });
        this._groups.data(data);
        this.setupProxy({
            rect: "_rects",
            label: "_labels",
        });
    };
    return Partition;
}(HierarchyLayout));
exports.Partition = Partition;
//# sourceMappingURL=hierarchy-layout.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/hierarchy-layout.js
// module id = 1158
// module chunks = 0 1